import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCleanserGlyphSecondary from './svgs/CleanserGlyphSecondary.js';
import SvgCleanserGlyph from './svgs/CleanserGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cleanserGlyph = (props => useIcon(SvgCleanserGlyph, SvgCleanserGlyphSecondary, props));

export { cleanserGlyph as default };
